<template>
  <div>
    <b-modal
      v-model="modalShow"
      size="lg"
      title="Export"
      :static="true"
      :lazy="true"
      hide-footer
      :no-close-on-backdrop="busy"
      :no-close-on-esc="busy"
      :hide-header-close="busy"
    >
      <div class="modal-body">
        <div v-if="error" class="alert alert-danger" role="alert">{{ error }}</div>
        <form class="">
          <fieldset :disabled="busy">
          <div class="form-row">
            <div class="form-group col">
              <label class="form-label" for="localization-export-language">Language</label>
              <b-form-select id="localization-export-language" v-model="code" :options="codeOptions"></b-form-select>
            </div>
            <div class="form-group col"><label class="form-label">Format</label>
              <div class="pt-1">
                <div class="form-check form-check-inline">
                  <b-form-radio v-model="format" name="format" value="json">json</b-form-radio>
                </div>
                <div class="form-check form-check-inline">
                  <b-form-radio v-model="format" name="format" value="csv">csv</b-form-radio>
                </div>
              </div>
            </div>
            <div class="form-group col"></div>
            <div class="d-flex align-items-end justify-content-end form-group col-sm-2">
              <button type="button" @click="exportTranslation" class="btn btn-success btn-sm">Export</button>
            </div>
          </div>
          <button v-if="pinnedRelease" type="button" @click="exportBundle" class="btn btn-outline-secondary btn-sm"><i class="fa fa-download"></i> All languages JSON</button>
          </fieldset>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalShow: false,
      format: 'json',
      code: 'en', busy: false, error: '', pinnedRelease: null
    }
  },
  props: [
    'languages', 'releaseId'
  ],
  methods: {
    exportTranslation() {
      return this.download('/api/v1/localization/export/' + this.code + '.' + this.format, this.code + '.' + this.format,
        this.pinnedRelease ? {release: this.pinnedRelease} : {});
    },
    exportBundle() {
      return this.download('/api/v1/localization/releases/' + this.pinnedRelease, 'languages-' + this.pinnedRelease + '.json');
    },
    async download(url, filename, params = {}) {
      if (this.busy) return;
      this.busy = true; this.error = '';
      try {
        const response = await this.$http({url, params, method: 'GET', responseType: 'blob'});
        const fileURL = window.URL.createObjectURL(response.data);
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', filename);
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.remove();
        setTimeout(() => window.URL.revokeObjectURL(fileURL), 1000);
        this.modalShow = false;
      } catch (err) {
        this.error = 'Export failed.';
        try {
          const value = err.response && err.response.data;
          const data = value instanceof Blob ? JSON.parse(await value.text()) : value;
          if (data && data.message) this.error = data.message;
        } catch (_) { /* Keep the bounded fallback for non-JSON transport errors. */ }
      } finally { this.busy = false; }
    },
    toggle() {
      if (this.busy) return;
      this.error = '';
      this.pinnedRelease = this.releaseId || null;
      this.modalShow = !this.modalShow;
    },
  },
  computed: {
    codeOptions() {
      return this.languages
        .map((item) => {
          return {value: item.code, text: item.name + ' (' + item.code + ')'}
        })
        .sort((a,b) => a.text > b.text ? 1 : -1);
    }
  },
}
</script>
